import { ComponentAuthorisation } from "../../components/ComponentAuthorisation";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { currencyFormatter } from "../../utils/Utils";

export default function InvoiceLines({ invoiceLines, currencyCode }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Return Order Lines">
        <TableHead>
          <TableRow>
            <TableCell>Product</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Wearer</TableCell>
            <TableCell>Branch</TableCell>
            <TableCell>Reference</TableCell>
            <TableCell>Ordered By</TableCell>
            {/* <TableCell>Colour</TableCell> */}
            {/* <TableCell>Size</TableCell> */}
            {/* <TableCell>Fit</TableCell> */}
            <ComponentAuthorisation allowedRoles={["allowentitlement"]}>
              <TableCell>Over Entitlement Reason</TableCell>
            </ComponentAuthorisation>
            <TableCell>Qty</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoiceLines?.map((line, index) => (
            <TableRow
              key={index}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell>{line.no}</TableCell>
              <TableCell>{line.description}</TableCell>
              <TableCell>
                {line.wearerName} ({line.wearerId})
              </TableCell>
              <TableCell>{line.branch}</TableCell>
              <TableCell>{line.custReference}</TableCell>
              <TableCell>{line.orderedName}</TableCell>
              {/* <TableCell>{line.colour}</TableCell> */}
              {/* <TableCell>{line.size}</TableCell> */}
              {/* <TableCell>{line.fit}</TableCell> */}
              <ComponentAuthorisation allowedRoles={["allowentitlement"]}>
                <TableCell>{line.overEntitlementReason}</TableCell>
              </ComponentAuthorisation>
              <TableCell>{line.quantity}</TableCell>
              <TableCell>
                {currencyFormatter(currencyCode, line.unitPrice)}
              </TableCell>
              <TableCell>
                {currencyFormatter(currencyCode, line.amount)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// type: "2",
// unitOfMeasure: "PCS",
// orderedId: "MCO108062",
